type StoreState = {
    company_name: string;
    your_name: string;
    email: string;
    tel: string;
    project_detail_section: string[];
    yoto_naiyo1: string;
    yoto_menseki1: string;
    shinsakikan_sinseitaio: string;
    mitsumori_iraijino_kibonoki: string;
    agree: boolean;
};

type StoreGetter = () => StoreState;

export class EntryValidator {

    private getStore?: StoreGetter;

    setStoreGetter(getter: StoreGetter) {
        this.getStore = getter;
    }

    validate(name: string, value: string | boolean): string {
        switch (name) {
            case 'company_name':
                return this.validateCompanyName(value as string);
            case 'your_name':
                return this.validateYourName(value as string);
            case 'email':
                return this.validateEmail(value as string);
            case 'tel':
                return this.validateTel(value as string);
            case 'project_detail_section':
                return this.validateProjectDetailSection();
            case 'yoto_naiyo1':
                return this.validateRequired(value as string, '用途を入力して下さい');
            case 'yoto_menseki1':
                return this.validateRequired(value as string, '延床面積を入力して下さい');
            case 'shinsakikan_sinseitaio':
                return this.validateRequired(value as string, '審査機関対応の有無を選択して下さい');
            case 'mitsumori_iraijino_kibonoki':
                return this.validateRequired(value as string, '希望納期を選択して下さい');
            case 'agree':
                return this.validateAgree(value as boolean);
            default:
                return '';
        }
    }

    private validateRequired(value: string, message: string): string {
        if (!value.trim()) {
            return message;
        }
        return '';
    }

    private validateCompanyName(value: string): string {
        return this.validateRequired(value, '会社名を入力して下さい');
    }

    private validateYourName(value: string): string {
        return this.validateRequired(value, 'お名前を入力して下さい');
    }

    private validateEmail(value: string): string {
        if (!value.trim()) {
            return 'メールアドレスを入力して下さい';
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            return '正しいメールアドレスを入力して下さい';
        }
        return '';
    }

    private validateTel(value: string): string {
        if (!value.trim()) {
            return '電話番号を入力して下さい';
        }
        if (!/^\d{5,13}$/.test(value)) {
            return '正しい電話番号を入力して下さい';
        }
        return '';
    }

    private validateProjectDetailSection(): string {
        const store = this.getStore?.();
        if (!store || store.project_detail_section.length === 0) {
            return '対応種別を1つ以上選択して下さい';
        }
        return '';
    }

    private validateAgree(value: boolean): string {
        if (!value) {
            return '個人情報の取り扱いに同意して下さい';
        }
        return '';
    }

    validateAll(): { errors: Record<string, string>; errorCount: number } {
        const store = this.getStore?.();
        if (!store) {
            return { errors: {}, errorCount: 0 };
        }

        const fields: { name: string; value: string | boolean }[] = [
            { name: 'company_name', value: store.company_name },
            { name: 'your_name', value: store.your_name },
            { name: 'email', value: store.email },
            { name: 'tel', value: store.tel },
            { name: 'project_detail_section', value: '' },
            { name: 'yoto_naiyo1', value: store.yoto_naiyo1 },
            { name: 'yoto_menseki1', value: store.yoto_menseki1 },
            { name: 'shinsakikan_sinseitaio', value: store.shinsakikan_sinseitaio },
            { name: 'mitsumori_iraijino_kibonoki', value: store.mitsumori_iraijino_kibonoki },
            { name: 'agree', value: store.agree },
        ];

        const errors: Record<string, string> = {};
        let errorCount = 0;

        for (const field of fields) {
            const error = this.validate(field.name, field.value);
            errors[field.name] = error;
            if (error) {
                errorCount++;
            }
        }

        return { errors, errorCount };
    }
}
